import React from 'react';
import { Toaster as Sonner } from 'sonner';
import { useTheme } from '@shared/theme/ThemeContext';

export type ToasterProps = React.ComponentProps<typeof Sonner>;

export const Toaster: React.FC<ToasterProps> = ({ ...props }) => {
  let themeMode: 'light' | 'dark' = 'light';
  try {
    const { theme } = useTheme();
    themeMode = theme;
  } catch {
    if (typeof document !== 'undefined') {
      themeMode =
        document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
    }
  }

  return (
    <Sonner
      theme={themeMode}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton:
            'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton:
            'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
      }}
      {...props}
    />
  );
};
